import { Text } from './text/component.js';
import { Title } from './title/index.js';
import { TitleMobile } from './title-mobile/component.js';
import { TitleResponsive } from './title-responsive/component.js';
import 'tslib';
import 'react';
import 'react-merge-refs';
import 'classnames';
import './hooks/use-skeleton.js';
import '../../skeleton/esm';
import '@alfalab/hooks';
import './colors.module-113b9747.js';
import './title/component.js';
import './title/utils.js';
import './common.module-aa1a707c.js';
import '../../mq/esm';

var Typography = {
    Title: Title,
    Text: Text,
    TitleResponsive: TitleResponsive,
    TitleMobile: TitleMobile,
};

export { Text, Title as TitleDesktop, TitleMobile, TitleResponsive, Typography };
